import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateDiff',
    standalone: false
})
export class DateDifferencePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let currentDate = new Date();
    const dateSent = new Date(value);

    return Math.floor((
      Date.UTC(currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate()) - Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate())
    ) / (1000 * 60 * 60 * 24));
  }

}
